import kotlinx.js.jso
import react.dom.html.HTMLAttributes

fun HTMLAttributes<*>.setUnsafeInnerHTML(html: String) {
    dangerouslySetInnerHTML = jso {
        __html = html
    }
}